import React from 'react'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import { Container } from '@mui/material'
import AppForm from '../form/AppForm'
import AppInput from '../form/AppInput'
import SubmitButton from '../form/SubmitButton'
import Header from '../form/Header'
import { formTypeList } from '../../constants/form'
import {
    addNewDoorColor,
    updateDoorColor,
} from '../../store/actions/doorColorAction'

const validationSchema = Yup.object().shape({
    name: Yup.string().required().label('Name'),
    picLink: Yup.string().required().label('Pic Link'),
    colorCode: Yup.string().required().label('Color Code'),
})

const Form = ({ formType, setOpen, doorStyleId = null, propsValue = null }) => {
    const dispatch = useDispatch()
    return (
        <Container>
            <Header
                title={`${formType === formTypeList.NEW ? 'ADD' : ''}${
                    formType === formTypeList.EDIT ? 'EDIT' : ''
                } DOOR STYLE`}
            />
            <AppForm
                initialValues={{
                    name: propsValue ? propsValue.name : '',
                    picLink: propsValue ? propsValue.picLink : '',
                    colorCode: propsValue ? propsValue.colorCode : '',
                }}
                onSubmit={(values) => {
                    const submitValues =
                        formType === formTypeList.NEW
                            ? { ...values, doorStyleId }
                            : { ...propsValue, ...values }
                    formType === formTypeList.NEW
                        ? dispatch(
                              addNewDoorColor(submitValues),
                              setOpen(false)
                          )
                        : dispatch(
                              updateDoorColor(submitValues),
                              setOpen(false)
                          )
                }}
                validationSchema={validationSchema}
            >
                <AppInput
                    name="name"
                    label="Name"
                    type="text"
                    inputProps={{
                        maxLength: 100,
                    }}
                    required={true}
                />
                <AppInput
                    name="colorCode"
                    label="Color Code"
                    type="text"
                    inputProps={{
                        maxLength: 10,
                    }}
                    required={true}
                />
                <AppInput
                    name="picLink"
                    label="Pic Link"
                    type="text"
                    inputProps={{
                        maxLength: 255,
                    }}
                    required={true}
                />
                <SubmitButton title="Submit" />
            </AppForm>
        </Container>
    )
}

export default Form
